var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMove = function SvgMove(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4606 2.821L9.33938 0.359391C9.10427 0.135574 8.78951 0.0111007 8.46177 0.0158798L1.99764 0.0235162C0.89399 0.0248201 0 0.919869 0 2.02351V13.8329C0 14.9375 0.895431 15.8329 2 15.8329H18C19.1046 15.8329 20 14.9375 20 13.8329V4.82413C20 3.72 19.1053 2.82475 18.0011 2.82413L12.4606 2.821ZM2 2.02351L8.21043 2.01618L11.7663 4.8206L18 4.82413V13.8329L2 13.8329L2 2.02351ZM9.68967 6.37411L10.2529 5.87925C10.4083 5.74183 10.6464 5.7576 10.783 5.91379L13.382 8.88224C13.5059 9.02417 13.5059 9.23518 13.382 9.3771L10.783 12.3463C10.6464 12.5025 10.4083 12.5183 10.2521 12.3808L9.68967 11.886C9.53422 11.7486 9.5192 11.512 9.65512 11.3566L10.9482 9.88098H5.59031C5.38305 9.88098 5.21484 9.71277 5.21484 9.50552V8.75458C5.21484 8.54732 5.38305 8.37911 5.59031 8.37911H10.9482L9.65512 6.90352C9.5192 6.74733 9.53422 6.51079 9.68967 6.37411Z",
    fill: "#9CA4B5"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMove, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/move.1c1a8e09.svg";
export { ForwardRef as ReactComponent };